// @flow
import React, {useState} from 'react';
import type {Node} from 'react';
import type {PropsType as IconPropsType} from '@wellstone-solutions/web';
import {Progress} from '@wellstone-solutions/web';
import {PfButton} from 'components/shared/PfButton';
import {Tooltip} from '@mui/material';
import {PfConfirmInline} from 'components/shared/PfConfirmInline';

type PropsType = {
  onActionClick?: () => void | Promise<void>,
  actionIcon?: string,
  actionIconProps?: IconPropsType,
  actionOverride?: () => void,
  entityType?: string,
};

export const CardDataListHeaderAction = ({
  onActionClick,
  actionIcon,
  actionIconProps,
  actionOverride,
  entityType,
}: PropsType): Node => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showConfirm, setShowConfirm] = useState<boolean>(false);

  const actionLabel = entityType === 'member' ? 'Discharge' : 'Remove';

  if (!onActionClick && !actionOverride) {
    return <></>;
  }

  const onRemoveClick = () => {
    if (actionOverride) {
      actionOverride();
      return;
    }

    setShowConfirm(true);
  };

  const cancelRemove = () => {
    setShowConfirm(false);
  };

  const actionClickWrapper = async () => {
    setIsLoading(true);
    setShowConfirm(false);
    await onActionClick?.();
    setIsLoading(false);
  };

  if (isLoading) {
    return (
      <div style={styles.loading}>
        <Progress
          size="small"
          color="inherit"
          style={styles.progress}
          data-testid="loading-spinner"
        />
      </div>
    );
  }

  if (showConfirm) {
    return (
      <div style={styles.confirm}>
        <PfConfirmInline
          showConfirm={showConfirm}
          confirm={actionClickWrapper}
          cancelConfirm={cancelRemove}
          color="light"
        />
      </div>
    );
  }

  return (
    <Tooltip title={`${actionLabel} from Program`} placement="left">
      <div>
        <PfButton
          color="primary"
          onClick={onRemoveClick}
          style={styles.iconButton}
          data-testid="headerActionButton">
          {actionLabel}
        </PfButton>
      </div>
    </Tooltip>
  );
};

const styles = {
  iconButton: {
    marginRight: '11px',
    marginTop: '4px',
  },
  loading: {
    position: 'relative',
    right: '19px',
    top: '12px',
    height: '42px',
    width: '20px',
  },
  progress: {
    display: 'block',
  },
  confirm: {
    position: 'relative',
    right: '11px',
    top: '9px',
    height: '42px',
  },
};
